import React, { ChangeEvent, Component } from 'react';
import { CaseFieldPanel, CasePanelField, CaseSettings } from '../../../../../domain/case/CaseDomains';
import { TransactionJsonModel } from '../../../../../domain/stream/transaction/TransactionDomains';
import RoleHelper from '../../../../../RoleHelper';
import { FormicaSelectBoxItem } from '../../../../custom/FormicaSearchSelectBox';
import CustomEmptyComponent from '../../../../custom/CustomEmptyComponent';
import FormicaGroupedSearchSelectBox, { FormicaGroupSelectBoxItem } from '../../../../custom/FormicaGroupedSearchSelectBox';
import Icon from '../../../../../icons/Icon';
import ComponentName from '../../../../../constant/ComponentName';
import LanguageUtil from '../../../../../util/LanguageUtil';

class DomainConfigurationPanelCardComponent extends Component<Props, State> {
  public state: State = new State();

  public render() {
    const { panel, disabled } = this.props;
    const cursorClass = disabled ? 'cursor-not-allowed' : 'cursor-pointer';
    return (
      <div className={'overflow-y-scroll'}>
        <div className='grid grid-cols-1'>
          {panel.fields && panel.fields.length < 1 && (
            <div className={'flex w-full h-full items-center justify-center py-8'}>
              <CustomEmptyComponent label={LanguageUtil.get({ id: 'common.label.noFieldsYet', defaultMessage: 'There is no fields yet.' })} />
            </div>
          )}
          {panel?.fields?.map((field, index: number) => {
            return (
              <div
                key={index}
                className={`flex items-center w-full odd:[#F9FAFB3D] border-b-[1px] last:border-none border-[#EAECF0] box-border h-[44px] 2xl:h-[52px] py-4  ${cursorClass} gap-x-5 p-4`}
              >
                <input
                  className={'w-1/2 border-none outline-none bg-transparent h-full indent-3 placeholder:text-f-black-2 text-f-black-2'}
                  placeholder={LanguageUtil.get({ id: 'common.input.placeholder.addTitle', defaultMessage: '+ Add a Title' })}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => this.onChangeFieldName(e.target.value, field)}
                  disabled={!RoleHelper.canEdit('CaseConfiguration')}
                  value={field.title || ''}
                  data-testid={`${ComponentName.CONFIGURATION}_panel_${index}_name_input`}
                />
                <div className={'flex w-1/2'}>
                  <FormicaGroupedSearchSelectBox
                    placeholder={LanguageUtil.get({ id: 'common.input.placeholder.infoType', defaultMessage: 'Information Type' })}
                    options={this.prepareOptionsVariable()}
                    value={field.value}
                    ghost={true}
                    rounded
                    disabled={!RoleHelper.canEdit('CaseConfiguration')}
                    onChangeValue={(e: FormicaSelectBoxItem) => this.changeValue(e, field)}
                    data-testid={`${ComponentName.CONFIGURATION}_panel_${index}_variable_select`}
                  />
                </div>
                <div onClick={() => this.deleteField(field)}>
                  <Icon
                    icon={'delete'}
                    size={20}
                    className={`text-primary ${cursorClass}`}
                    data-testid={`${ComponentName.CONFIGURATION}_panel_${index}_remove_button`}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  private changeValue = (e: FormicaSelectBoxItem, field: CasePanelField) => {
    const { changePanel, disabled } = this.props;
    if (disabled) return;
    const type: string = e.value.split('-')[0];
    const name: string = e.value.slice(type.length + 1);
    field.type = type;
    field.value = name;
    changePanel();
  };

  private prepareOptionsVariable = (): FormicaGroupSelectBoxItem[] => {
    const { transaction, enrichmentNames } = this.props;
    const transactionOptions: FormicaGroupSelectBoxItem = {
      groupName: 'Transaction Variable',
      items:
        transaction?.variables.map((variable: any) => {
          return {
            label: variable.description && variable.description.length > 0 ? variable.description : variable.name,
            value: `TransactionVariable-${variable.name}`,
          };
        }) || [],
    };
    const groupOptions: FormicaGroupSelectBoxItem = {
      groupName: 'Enrichment Variable',
      items:
        enrichmentNames?.map((enrichment) => {
          return {
            label: enrichment,
            value: `EnrichmentVariable-${enrichment}`,
          };
        }) || [],
    };
    return [transactionOptions, groupOptions];
  };

  private onChangeFieldName = (value: string, field: CasePanelField) => {
    const { changePanel } = this.props;
    const { disabled } = this.props;
    if (disabled) return;
    field.title = value;
    changePanel();
  };

  private deleteField = (field: CasePanelField) => {
    const { panel, changePanel } = this.props;
    const { disabled } = this.props;
    if (disabled) return;
    const index = panel.fields.findIndex((f) => f.key == field.key);
    if (index > -1) {
      panel.fields.splice(index, 1);
      changePanel();
    }
  };
}

interface Props {
  panel: CaseFieldPanel;
  enrichmentNames: string[];
  changePanel: () => void;
  domainConfiguration: CaseSettings;
  transaction: TransactionJsonModel | undefined;
  disabled: boolean;
}

class State {}

export default DomainConfigurationPanelCardComponent;
